import moment from 'moment';

export const formatKeyAsDate = (key: string): string => {
  if (key.length !== 6) return key;

  const yearShort = parseInt(key.slice(0, 2), 10);
  const month = parseInt(key.slice(2, 4), 10);
  const day = parseInt(key.slice(4, 6), 10);

  const yearFull = 2000 + yearShort;
  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];
  const monthName = months[month - 1] || '???';

  return `${day} ${monthName} ${yearFull}`;
};

export const formatTimeString = (timeText: string): string => {
  return timeText.replace('.json', '').replace(/_/g, ':');
};

export const parseRiskSnapshots = (
  response: any,
): {
  key: string;
  label: string;
  timestamp: string;
}[] => {
  if (!response?.result) return [];

  const list: {
    key: string;
    label: string;
    timestamp: string;
  }[] = [];

  let counter = 0;

  Object.entries(response.result).forEach(([dateKey, items]) => {
    const dateString = formatKeyAsDate(dateKey);

    if (Array.isArray(items)) {
      items.forEach((item) => {
        const timeStr = formatTimeString(item);
        const label = `${dateString} - ${timeStr} UTC`;

        const timestamp = moment
          .utc(`${dateString} ${timeStr}`, 'DD MMM YYYY HH:mm:ss')
          .toISOString();

        list.push({
          key: `risk-snapshot-${counter++}`,
          label,
          timestamp,
        });
      });
    }
  });

  list.sort((a, b) => {
    return moment(b.timestamp).valueOf() - moment(a.timestamp).valueOf();
  });

  return list;
};
